<template>
  <el-card shadow="never">
    <div class="goods-image-main">
      <div class="d-flex align-items-center">
        <span style="font-size: 14px; color: #606266">
          {{ data.orderGoodsName || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <div>
          <el-upload
            ref="uploader"
            multiple
            action="#"
            :show-file-list="false"
            :on-change="onGoodsImageChange"
            :auto-upload="false"
            accept=".jpeg,.jpg,.png,.gif"
          >
            <el-button class="ml-2" style="font-size: 14px;" type="text">
              {{ '上传图片' }}
            </el-button>
          </el-upload>
        </div>
      </div>
      <el-divider></el-divider>
      <GoodsImageList
        :data="data.listImage"
        @imageCheck="onGoodsImageCheck"
        @imageDel="onGoodsImageDel"
        :expandContent="data.isGroup === 'N'"
      />
      <div v-if="data.isGroup === 'Y'">
        <div v-for="(item, index) in data.listGoodsSpec || []" :key="index">
          <GoodsSpecImage
            :title="item.identifyGoodsName"
            :orderGoodsSpecCode="item.orderGoodsSpecCode"
            :orderGoodsCode="orderGoodsCode"
            :data="item.listImage"
            @reload="
              () => {
                loadData()
                $emit('reload')
              }
            "
            @imageCheck="
              (e) =>
                onGoodsSpecImageCheck({
                  ...e,
                  orderGoodsSpecCode: item.orderGoodsSpecCode,
                })
            "
            @imageDel="onGoodsImageDel"
          />
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import GoodsImageList from '../goods-image-list'
import EditLoading from '@/mixins/edit-loading'
import GoodsSpecImage from './components/goods-spec-images'
export default {
  mixins: [EditLoading],
  props: { orderGoodsCode: { type: String, default: '' } },
  components: { GoodsImageList, GoodsSpecImage },
  data() {
    return {
      listGoodsImage: [],
      data: {},
      uploadFileMaxLimit: 10,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.orderGoodsCode) return
      const res = await this.$api
        .orderGoodsSelectImageApi({
          orderGoodsCode: this.orderGoodsCode,
        })
        .catch(() => null)
      const { body, status } = res || {}
      if (status !== 200 || !body) return
      this.data = body
    },
    onGoodsImageChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }

      this.listGoodsImage.push(file)
      if (this.listGoodsImage.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (!this.listGoodsImage || !this.listGoodsImage.length) {
        this.$message.warning('请选择您需要上传的图片！')
        return
      }

      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        this.clearFiles()
        return
      }

      const params = { orderGoodsCode: this.orderGoodsCode, listImage }
      const res = await this.$api
        .orderGoodsImageUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.loadData()
      this.$emit('reload')
    },
    uploadImages() {
      if (!this.listGoodsImage || !this.listGoodsImage.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listGoodsImage.map((image) => {
        return this.$api
          .SYS_UPLOAD(image.raw)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
            originImageSpec: image.raw.type,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listGoodsImage = []
    },
    async onGoodsImageCheck({ orderGoodsImgCode }) {
      this.loadingOpen()
      const res = await this.$api
        .orderGoodsSetDefaultImageApi({
          orderGoodsCode: this.orderGoodsCode,
          orderGoodsImgCode,
        })
        .catch(() => null)
      this.loadingClose()

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error('设置失败')
        return
      }
      this.$message({
        showClose: true,
        message: '设置成功',
        type: 'success',
      })
      this.loadData()
      this.$emit('reload')
    },
    async onGoodsSpecImageCheck({ orderGoodsSpecCode, orderGoodsImgCode }) {
      this.loadingOpen()
      const res = await this.$api
        .orderGoodsSpecSetDefaultImageApi({
          orderGoodsSpecCode,
          orderGoodsImgCode,
        })
        .catch(() => null)
      this.loadingClose()

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error('设置失败')
        return
      }
      this.$message({
        showClose: true,
        message: '设置成功',
        type: 'success',
      })
      this.loadData()
      this.$emit('reload')
    },
    async onGoodsImageDel({ orderGoodsImgCode }) {
      this.loadingOpen()
      const res = await this.$api
        .orderGoodsImageDelApi({ orderGoodsImgCode })
        .catch(() => null)
      this.loadingClose()

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error('删除失败')
        return
      }
      this.$message({
        showClose: true,
        message: '删除成功',
        type: 'success',
      })
      this.loadData()
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.goods-image-main {
  height: calc(100vh - 10vh - 145px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-divider.el-divider--horizontal {
  margin: 5px 0;
}
::v-deep .el-card__body {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
